import { useState } from 'react';

interface ContactLogoProps {
  photoUrl: string;
  firstName?: string;
  lastName?: string;
}

const isPlaceholderImage = (photoUrl: string) => {
  return photoUrl.includes('placehold.co');
};

const ContactLogo = ({ photoUrl, firstName = '', lastName = '' }: ContactLogoProps) => {
  const [imageError, setImageError] = useState(false);
  const initials = `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`;

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="w-[32px] h-[32px]">
      {photoUrl && !isPlaceholderImage(photoUrl) && !imageError ? (
        <img
          src={photoUrl}
          alt="Contact Logo"
          className="!w-[32px] !h-[32px] object-cover rounded-full"
          onError={handleImageError}
        />
      ) : (
        <div className="!w-[32px] !h-[32px] flex items-center justify-center bg-[#c2dad9] dark:bg-[#08736D] rounded-full">
          <div className="text-center text-[#08736d] dark:text-[#C3DBD9] text-xs font-medium font-rooftopMedium tracking-tight">
            {initials}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactLogo;
